import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';

Vue.component('schedules', {
    components: {
        datePicker
    },

    data () {
        return {
            loading: false,

            firstTime: true,

            schedules: {},

            createForm: $.extend(true, new Form({
                data: {
                    start: '',
                    finish: '',
                    day: '',
                    week: '',
                    user: '',
                    client: '',
                    target: 25
                }
            }), {}),

            editForm: $.extend(true, new Form({
                data: {
                    id: '',
                    start: '',
                    finish: '',
                    day: '',
                    week: '',
                    user: '',
                    client: '',
                    target: 25
                }
            }), {}),

            tpOptions: {
                format: 'HH:mm',
            },

            clients: {},

            users: {}
        };
    },

    mounted () {
        this.getSchedules();
    },

    methods: {
        getSchedules () {
            if (this.firstTime) {
                this.loading = true;
            }

            axios.get('/api/schedules/').then(response => {
                this.schedules = response.data.schedule;
                this.users = response.data.users;

                this.firstTime = false;
                this.loading = false;
            });
        },

        getClients () {
            this.setClient(this.createForm.data.user);
        },

        setClient (id) {
            for (let user in this.users) {
                if (this.users[user].id == id) {
                    this.clients = this.users[user].clients;
                }
            }
        },

        create () {
            $('#create').modal('show');
        },

        createForUser (user, week) {
            this.createForm.data.user = user;
            this.createForm.data.week = week;

            this.getClients();

            $('#create').modal('show');
        },

        store () {
            Http.post('/api/schedules/create/', this.createForm).then(response => {
                this.getSchedules();

                this.createForm.resetForm();

                $('#create').modal('hide');
            });
        },

        edit(item) {
            this.setClient(item.user_id);

            $('#edit').modal('show');

            this.editForm.data.id = item.id;
            this.editForm.data.user = item.user_id;
            this.editForm.data.client = item.client_id;
            this.editForm.data.start = item.start;
            this.editForm.data.finish = item.finish;
            this.editForm.data.day = item.day;
            this.editForm.data.target = item.target;
            this.editForm.data.week = item.week;
        },

        update () {
            Http.post('/api/schedules/update', this.editForm).then((response) => {
                this.getSchedules();

                this.editForm.resetForm();

                $('#edit').modal('hide');
            });
        },

        deleteSchedule(id) {
            this.deleteId = id;
            $('#delete').modal('show');
        },

        doDeleteSchedule () {
            axios.post('/api/schedules/delete', {}, {
                params: {
                    id: this.deleteId
                }
            }).then(response => {
                $('#delete').modal('hide');

                this.getSchedules();
            });
        },
    }
});